/* eslint-disable func-names */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';

Vue.use(VueAxios, axios);
Vue.use(VueAwesomeSwiper);


// 自定义指令
Vue.directive('title', {// 单个修改标题
  // eslint-disable-next-line no-unused-vars
  inserted(el, binding) {
    document.title = el.dataset.title;
  },
});


// 公共方法
Vue.prototype.showLoading = function () {
  this.$toast.loading({
    duration: 0, // 持续展示 toast
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
  });
};

Vue.prototype.hideLoading = function () {
  this.$toast.clear();
};
